import React from "react";
import DataSlider from "../slider";
import { Tooltip } from "@paylixecommerce/shared/components";
import { MoreInfo } from "../../entrypoints/dashboard/layouts/dashboard/sidebar/icons/icons/icons";

export default ({ label, domain, skipMargin, wrapperClassName, name, suffix, ticks, tooltip, values, handleChange, note, skipNote, styles }) => {

	return <div className={skipMargin ? "" : "mb-4"}>
		<label className="paylixecommerce-label mb-3">
			{label ? <>{label}&nbsp;&nbsp;</> : null}
			{label && tooltip ?
				<span className="ml-1">
					<Tooltip tooltipText={tooltip} name={name} >
						<MoreInfo />
					</Tooltip>
				</span>
			: null}
		</label>
		<DataSlider
			wrapperClassName={wrapperClassName}
			suffix={suffix}
			styles={styles}
			domain={domain}
			ticks={ticks}
			value={[values[name]]}
			receiveValue={(value) => {
				handleChange(name)({ target: { type: "test", value }})
			}}
		/>
		{skipNote ? null : <span style={{ marginTop: "-2rem" }} className="paylixecommerce-note" >{note ? note : ''}&nbsp;</span>}
	</div>
}
